module.exports = __webpack_public_path__ + "img/close.ecdf958e.svg";